module.exports = __webpack_public_path__ + "white-arrow.png";